import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Header = styled.header`
	display: flex;
	justify-content: ${(props) => (props.centered ? 'center' : 'flex-start')};
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
	margin-bottom: -1rem;
	padding: 1.5rem 2rem 0;
	color: ${({ theme }) => theme['white']};
	font-family: ${({ theme }) => theme['base-font-family']};

	& > * {
		margin: 0;
		line-height: 1.5;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
		font-size: 2rem;
		font-weight: 500;
		text-align: ${(props) => props.centered ? 'center' : 'left'};
	}
`;

const ModalHeader = ({ ...props }) => <Header {...props} />;

ModalHeader.propTypes = {
	centered: PropTypes.bool
};

export default ModalHeader;
